<template>
  <div class="member-area-students-filter">
    <div>
      <form-group
        v-model="is_enable"
        id="filter-status"
        label="Status do aluno"
        placeholder="Selecione o status"
        select
        :options="status"
      />
      <div
        class="d-flex align-items-center justify-content-center text-center pt-6"
      >
        <button class="btn btn-secondary mr-3 px-6 w-50" @click="clear">
          Cancelar
        </button>
        <button class="btn btn-primary ml-3 px-6 w-50" @click="apply">
          Aplicar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_enable: this.value,
      status: [
        { id: "", name: "Todos" },
        { id: "active", name: "Ativo" },
        { id: "inactive", name: "Inativo" }
      ]
    };
  },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.is_enable);
      this.$emit("submit");
      this.$emit("close");
    },
    clear() {
      this.is_enable = "";
      this.apply();
    }
  }
};
</script>
